import { GetBirthdayRewardModel } from "@factory/model/query-model-birthday-reward";
import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";

import { birthdayRewardFormDefault } from "./form.default";
import { BirthdayRewardFormSchema } from "./form.rule";

export const useFormDefaultBirthdayReward = () => {
  const { formatDate } = useDateTimeContext();

  const getDefault = (cachedValue: GetBirthdayRewardModel | undefined) => {
    return !cachedValue
      ? birthdayRewardFormDefault
     : ({
        tenant: cachedValue.tenant,
        points: cachedValue.points,
        stamp: cachedValue.stamp,
        expiryDays: cachedValue.expiry_days,
      } as BirthdayRewardFormSchema);
  };

  return {
    getDefault,
  };
};
